import { render } from "./CalculationRiver.vue?vue&type=template&id=fc5682ee&scoped=true"
import script from "./CalculationRiver.vue?vue&type=script&lang=js"
export * from "./CalculationRiver.vue?vue&type=script&lang=js"

import "./CalculationRiver.vue?vue&type=style&index=0&id=fc5682ee&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc5682ee"]])

export default __exports__